<template>
	<div>
		<el-dialog :show-close="false" :before-close="()=>{
			dialogVisible = false
		}" ref="globalDialog" v-if="all_setting.length > 0" :style="{
			'--borderRadius':getBorderRadius(),
			'--borderTop':`${globalDialog.border.borderSize[0]}px ${globalDialog.border.color} ${globalDialog.border.type}`,
			'--borderBottom':`${globalDialog.border.borderSize[2]}px ${globalDialog.border.color} ${globalDialog.border.type}`,
			'--borderLeft':`${globalDialog.border.borderSize[1]}px ${globalDialog.border.color} ${globalDialog.border.type}`,
			'--borderRight':`${globalDialog.border.borderSize[3]}px ${globalDialog.border.color} ${globalDialog.border.type}`,
		}" custom-class="dialog-custom" :modal="false" append-to-body modal-append-to-body :title="' '"
			:visible.sync="dialogVisible"
			:width="equipment == 'pc'?(globalDialog.width + 'px'): (globalDialog.phoneWidth + 'px')">
			<div :style="{
				height:equipment == 'pc'?(globalDialog.height + 'px'):(globalDialog.phoneHeight + 'px')
			}" style="width: 100%;overflow-y: scroll;position: relative;">
				<div style="position: absolute;right: 4px;top: 0px;z-index: 1000;cursor: pointer;"
					@click="dialogVisible = false">
					<i class="el-icon-close"></i>
				</div>
				<div style="width: 100%;" :style="{
				...getPadding()
			}">
					<wm-preview :all_setting="all_setting" typeView="build" :systemConfig="systemConfig"
						:equipment="equipment" :list="centerList"></wm-preview>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
		import apiConfig from '../config/apiConfig.js'
	import config from '../config.js'
	import wmPreview from '../components/preview.vue'
	export default {
		components: {
			wmPreview
		},
		props: {
			all_setting: {
				type: Array,
				default: () => {
					return []
				}
			},
			equipment: {
				type: String,
				default: ''
			},
			configRequest: {
				type: Object,
				default: () => {
					return {}
				}
			},
			systemConfig: {
				type: Object,
				default: () => {
					return {}
				}
			}
		},
		watch: {
			all_setting: {
				immediate: true,
				deep: true,
				handler: function(newVal, oldVal) {
					// !localStorage.getItem('openDialog')
					if (newVal.length > 0) {
						
						
						
						console.log('newVal[0].tabList[2].config.globalDialog',newVal[0].tabList[2].config.globalDialog)
						
						if (newVal[0].tabList[2].config.globalDialog) {
							
							if(newVal[0].tabList[2].config.globalDialog.isOpen) {
								if(newVal[0].tabList[2].config.globalDialog.closeNoShow == 'false'){
									localStorage.setItem('closeNoShow','false')
								}
								
								
								if(localStorage.getItem('closeNoShow') == 'false') {
									if (newVal[0].tabList[2].config.globalDialog.onlyHomeShow == 'true') {
										if (this.$route.path == '/') {
											this.authOpenTime()
										}
									} else {
										this.authOpenTime()
									}
								}else{
									if(localStorage.getItem('closeNoShow') != 'true'){
										if (newVal[0].tabList[2].config.globalDialog.onlyHomeShow == 'true') {
											if (this.$route.path == '/') {
												this.authOpenTime()
											}
										} else {
											this.authOpenTime()
										}
									}
								}
								
								
								
								
								if(newVal[0].tabList[2].config.globalDialog.closeNoShow == 'true'){
									localStorage.setItem('closeNoShow','true')
								}
							}
						}
					}
				}
			},
		},
		computed: {
			globalDialog: function() {
				if (this.all_setting.length > 0) {
					if (this.all_setting[0].tabList[2].config.globalDialog) {

						return this.all_setting[0].tabList[2].config.globalDialog
					}
				}
			},
			fontList: function() {
				if (this.all_setting.length > 0) {
					let itemSetFont = this.all_setting[0].tabList[1]
					return itemSetFont.config.setfontFamily.fontList
				}
			}
		},
		data() {
			return {
				config,
				centerList: [],
				dialogVisible: false
			}
		},
		mounted() {
			
			if (this.all_setting.length > 0) {
				if (this.all_setting[0].tabList[2].config.globalDialog) {
			
					if (!this.all_setting[0].tabList[2].config.globalDialog.onlyHomeShow) {
						this.$set(this.all_setting[0].tabList[2].config.globalDialog, 'onlyHomeShow', 'true')
					}
			
					if (!this.all_setting[0].tabList[2].config.globalDialog.closeNoShow) {
						this.$set(this.all_setting[0].tabList[2].config.globalDialog, 'closeNoShow', 'true')
					}
				}
			}
			
			this.requestFun({}, '', {})
		},
		methods: {
			getPadding() {
				return {
					// 实际上是 margin
					marginTop: this.globalDialog.padding[0] + 'px',
					marginBottom: this.globalDialog.padding[2] + 'px',
					marginLeft: this.globalDialog.padding[1] + 'px',
					marginRight: this.globalDialog.padding[3] + 'px'
				}
			},
			getFontStyle(e) {
				let item;
				console.log('getFontStyle', this.fontList)
				this.fontList.forEach(fontItem => {
					if (fontItem.name == e) {
						item = fontItem
					}
				})
				if (item) {
					if (!document.getElementById(item.name)) {
						var style = document.createElement('style');
						style.type = 'text/css';
						style.id = item.name
						style.innerHTML = item.css;
						document.getElementsByTagName('HEAD').item(0).appendChild(style);
					}
				}
			},

			cssStringToObject(cssString) {
				const styleObject = {};

				// 移除所有注释（可选）
				const cleanedCss = cssString.replace(/\/\*[\s\S]*?\*\//g, '');

				// 分割每条规则
				const rules = cleanedCss.split(';').filter(rule => rule.trim() !== '');

				rules.forEach(rule => {
					const [property, value] = rule.split(':').map(item => item.trim());
					if (property && value) {
						// 转换属性名为驼峰式（如 background-color -> backgroundColor）
						const camelCaseProperty = property.replace(/-([a-z])/g, (g) => g[1].toUpperCase());
						styleObject[camelCaseProperty] = value;
					}
				});
				return styleObject;
			},
			getTit() {

			},
			getBgColor() {
				const element = this.$refs.globalDialog;
				// 添加字体
				element.style.fontFamily = this.globalDialog.fontFamily

				if (this.globalDialog.bg.bgType == 'color') {
					element.style.backgroundColor = this.globalDialog.bg.bgColor
				}
				if (this.globalDialog.bg.bgType == 'gradient') {
					let obj = this.cssStringToObject(this.globalDialog.bg.bgGradient)
					for (let k in obj) {
						element.style[k] = obj[k]
					}
				}
				if (this.globalDialog.bg.bgType == 'img') {
					element.style.backgroundImage = `url(${this.globalDialog.bg.bgImg.url})`

					if (this.globalDialog.bg.bgImg.width) {
						element.style.backgroundSize = this.globalDialog.bg.bgImg.width + 'px'
					} else {
						element.style.backgroundSize = '100%'
					}

					if (this.globalDialog.bg.bgImg.height) {
						element.style.backgroundSize = element.style.backgroundSize + ' ' + (this.globalDialog.bg.bgImg
							.height + 'px')
					} else {
						element.style.backgroundSize = element.style.backgroundSize + ' 100%'
					}

					if (this.globalDialog.bg.bgImg.type) {
						element.style.backgroundRepeat = this.globalDialog.bg.bgImg.type
					}

					if (this.globalDialog.bg.bgImg.position) {
						element.style.backgroundPosition = this.globalDialog.bg.bgImg.position
					}
				}
			},
			authOpenTime() {
				let that = this
				setTimeout(() => {
					that.dialogVisible = true
					that.getFontStyle(this.globalDialog.fontFamily)
					that.getBgColor()
					// 全局打开一次
					// 打开之后是否自动关闭
					if (that.globalDialog.authClose) {
						that.authCloseTime()
					}

				}, that.globalDialog.comeOpenTime * 1000)
			},
			authCloseTime() {
				let that = this
				setTimeout(() => {
					that.dialogVisible = false
				}, that.globalDialog.authCloseTime * 1000)

			},

			getBorderRadius() {
				return `${this.globalDialog.border.borderRadius[0]}px ${this.globalDialog.border.borderRadius[1]}px ${this.globalDialog.border.borderRadius[2]}px ${this.globalDialog.border.borderRadius[3]}px`
			},

			getField(type) {
				let filed = 'navList'
				this.config.center.page.forEach(pageItem => {
					if (pageItem.type == type) {
						filed = pageItem.filed
					}
				})

				return filed
			},

			// 重新装配 导航
			async requestFun(obj, path, to) {
				// 获取页面配置对应的键值对
				let pageType = 'globalDialogList'
				// 获取当前导航 和 页面配置
				if (this.configRequest.data.data.list) {
					// 页面配置
					let listObj = this.configRequest.data.data.list
					for (let i in listObj) {
						let field = this.getField(i)
						if (i == pageType) {
							this['centerList'] = JSON.parse(listObj[i])
						} else {
							if (i != 'bottomCartPhone') {
								this[field] = JSON.parse(listObj[i])
							}
						}
					}
				}
				await this.requestInitData('centerList', obj, to)
			},

			// 重新装配 导航
			async requestInitData(fieldList, obj, to) {
				let that = this
				for (let i = 0; i < this[fieldList].length; i++) {
					let item = this[fieldList][i]
					console.log('requestInitData item', item)
					if (item.requestFun) {
						for (let j = 0; j < item.children.length; j++) {
							let childrenItem = item.children[j]
							for (let k = 0; k < childrenItem.children.length; k++) {
								let twoChildrenItem = childrenItem.children[k]
								for (let m = 0; m < twoChildrenItem.compontChildren.length; m++) {
									let compontChildrenItem = twoChildrenItem.compontChildren[m]
									console.log('compontChildrenItem', compontChildrenItem)
									console.log('obj', obj)
									await that.initData(compontChildrenItem, obj, to, childrenItem, twoChildrenItem,
										item)
								}
							}
						}
					}
				}
			},

			async initData(compoent, obj, to, childrenItem, twoChildrenItem, item) {
				this.loading = true
				let that = this
				try {
					let name = compoent.compoentName
					for (let i = 0; i < apiConfig.length; i++) {
						let fun = apiConfig[i]
						if (fun[name]) {
							if (compoent.requestFun) {
								for (let j = 0; j < compoent.requestFun.length; j++) {
									let funName = compoent.requestFun[j]
									let data = await fun[name]['requestData'][funName](that, 'build', {
										classfiy: compoent.data,
										data: compoent,
										list: obj,
										childrenItem,
										twoChildrenItem,
										item
									}, to)
								}
							}
						}
					}
					this.loading = false
				} catch (e) {
					console.log('e', e)
					this.loading = false
				}
			},
		}
	}
</script>

<style scoped lang="scss">
	::v-deep .dialog-custom {
		border-radius: var(--borderRadius);
		border-top: var(--borderTop);
		border-bottom: var(--borderBottom);
		border-left: var(--borderLeft);
		border-right: var(--borderRight);
		// background-color: var(--bgColor);
		// background-image: var(--bgGradient);
	}

	::v-deep .el-dialog__header {
		padding: 0px;
		height: 0px
	}

	::v-deep .el-dialog__header .el-dialog__title {
		// color: var(--titColor);
		// /* 绿色标题 */
		// font-size: var(--titFontSize);
	}

	::v-deep .el-dialog__body {
		padding: 0px;
	}

	::v-deep .el-dialog__header .el-dialog__headerbtn .el-icon-close {
		color: #ff5500;
		z-index: 1000000000000000000000000000000000 !important;
		position: relative;
	}

	::v-deep .el-dialog__header .el-dialog__headerbtn {
		top: 4px;
		right: 4px;
	}
</style>